var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toast } from 'react-toastify';
import { ToastWrapper, Sections, DescriptionText, IconSections, TitleText, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';
var toastBody = function (type, msg, description) {
    return (_jsxs(ToastWrapper, __assign({ type: type }, { children: [_jsx(IconSections, __assign({ type: type }, { children: _jsx(FontAwesomeIcon, { icon: type === 'success' ? faCheckCircle : faExclamationCircle, style: { fontSize: '24px', marginRight: '16px' } }) })), _jsxs(Sections, { children: [_jsx(TitleText, { children: msg }), description && _jsx(DescriptionText, { children: description })] })] })));
};
var StyledToast = {
    success: function (msg, containerId, description) {
        toast.success(toastBody('success', msg, description), {
            closeOnClick: true,
            containerId: containerId || 'cms',
            icon: false,
        });
    },
    error: function (msg, containerId, description) {
        toast.error(toastBody('error', msg, description), {
            closeOnClick: true,
            containerId: containerId || 'cms',
            icon: false,
        });
    },
    warn: function (msg, containerId, description) {
        toast.warn(toastBody('warning', msg, description), {
            closeOnClick: true,
            containerId: containerId || 'cms',
            icon: false,
        });
    },
    info: function (msg, containerId, description) {
        toast.info(toastBody('info', msg, description), {
            closeOnClick: true,
            containerId: containerId || 'cms',
            icon: false,
        });
    },
};
export default StyledToast;
